module.exports = __webpack_public_path__ + "img/812.c4cb2786.svg";